import { type ComponentProps } from 'react';
import { twJoin } from 'tailwind-merge';

import { Label } from '@/core/tamagoshiTailwind/components/Label/Label';
import { SponsoredLabel } from '@/core/tamagoshiTailwind/components/Label/SponsoredLabel';

type Props = {
  compact?: boolean;
  primaryLabel?: ComponentProps<typeof Label>;
  sponsored?: ComponentProps<typeof SponsoredLabel>;
};

export const Labels = ({ compact, primaryLabel, sponsored }: Props) => (
  <div
    className={twJoin(
      'flex h-[20px] w-full gap-xs overflow-hidden',
      // NOTE Force specificity by targeting the inner spans that should retain
      //      their default responsiveness outside of this component.
      compact && '[&_span]:text-tiny',
    )}
  >
    {primaryLabel && <Label {...primaryLabel} />}
    {sponsored && (
      // NOTE Bump the Z index in order to remain clickable above the parent
      //      click overlay.
      <div className="z-[1]">
        <SponsoredLabel {...sponsored} />
      </div>
    )}
  </div>
);
